<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'global.code' |translate}}</mat-label>
      <input matInput type="text" [formControl]="codeControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'global.description' |translate}}</mat-label>
      <input matInput type="text" [formControl]="descriptionControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" color="primary">
      <mat-label>Status</mat-label>
      <mat-select [formControl]="statusControl">
        <mat-option value="ACTIVE"> Active </mat-option>
        <mat-option value="INACTIVE"> Inactive </mat-option>
      </mat-select>
    </mat-form-field>


    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>

  </form>
</div>
